import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { ProfileInput } from '../profile';
import { ProfileService } from '../services/profile.service';
import { ProfileBaseGuard } from './profile-base.guard';

/**
 * Route guard to control the accessibility of the /profile/:id/settings route
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileSettingsGuard extends ProfileBaseGuard {
  constructor(
    private authUser: AuthService,
    @Inject('profileInput') protected profileInput: ProfileInput,
    protected profileService: ProfileService,
    protected router: Router
  ) {
    super(profileInput, router, profileService);
  }

  public canLoad(_: Route): boolean {
    // always allow loading (when new profile settings are enabled) so that if the user is not authorized they can be
    // redirected to the settings-login page
    return true;
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const ownerAuthorized =
      this.isAuthorized &&
      this.profileService.ownerAuthorizedForGuard(route.parent);

    if (!ownerAuthorized) {
      const parentUrl = this.getParentUrl(route, state);
      return this.router.parseUrl(
        `${parentUrl}settings-login?returnUrl=${state.url}`
      );
    }
    return ownerAuthorized;
  }
}
